module.exports = __webpack_public_path__ + "static/media/Pupitar_gaussian2.6516915f.png";